<template>
    <div class="course-detail-page">
        <!-- 1、顶部菜单栏 -->
        <div class="course-title-bar dsp-flex">
            <div class="bg1"></div><div class="bg2"></div>
            <div class="title-side title-yellow">
                <span class="title-back discuss-title-back" @click="clickBack">
                    <i class="iconfont icon-xiangzuo"></i>
                </span>
            </div>
            <div class="title-middle">
                <span>课程详情</span>
            </div>
            <div v-if="curCourseInfo && curCourseInfo.needBuy < 100" class="title-side title-green" @click="clickCDKey">
                <span>兑换码</span>
            </div>
        </div>
        <!-- 2、课程基本信息 -->
        <div class="course-info">
            <div class="course-info-img">
                <img v-lazy="curCourseInfo.f_pic" />
            </div>
            <div v-if="curCourseInfo && curCourseInfo.needBuy < 100" class="course-info-price">
                <div class="course-info-price-left">
                    <div class="price-line-1">
                        <span class="course-price-1">￥<span class="price-num">{{ curCoursePayInfo.payPrice }}</span></span>
                        <span class="course-price-discount">限时折扣</span>
                        <span class="course-price-number">还剩{{ curCourseInfo ? curCourseInfo.limit : 0 }}个</span>
                    </div>
                    <div class="price-line-2">
                        <span class="course-price-origin-2">￥{{ curCoursePayInfo.ratePrice }}</span>
                    </div>
                </div>
                <div class="course-info-price-right">
                    <div class="info-line-1">距结束仅剩</div>
                    <div class="info-line-2">
                        {{ curCourseInfo && curCourseInfo.limitDay && curCourseInfo.limitDay != '00' ? curCourseInfo.limitDay+'天' : '' }}
                        <span class="info-time">{{ curCourseInfo && curCourseInfo.limitTime ? curCourseInfo.limitTime[0] : '' }}</span>:
                        <span class="info-time">{{ curCourseInfo && curCourseInfo.limitTime ? curCourseInfo.limitTime[1] : '' }}</span>:
                        <span class="info-time">{{ curCourseInfo && curCourseInfo.limitTime ? curCourseInfo.limitTime[2] : '' }}</span>
                    </div>
                </div>
            </div>
            <div class="course-info-content">
                <h3 class="course-info-title">{{ curCourseInfo.f_title }}</h3>
                <p class="course-info-sub-title">{{ curCourseInfo ? curCourseInfo.f_buy : 0 }}人购买</p>
            </div>
        </div>
        <!-- 3、课程详情、目录 -->
        <div class="course-detail-content">
            <div class="course-detail-tab">
                <span class="tab" :class="{'cur' : curTab == 'detail'}" @click="toggleTab('detail')">详情</span>
                <span class="tab" :class="{'cur' : curTab == 'catalogue'}" @click="toggleTab('catalogue')">目录</span>
            </div>
            <!-- 3.1、课程详情 -->
            <div v-if="curTab == 'detail'" class="course-detail-detail">
                <p v-html="detailContent"></p>
            </div>
            <!-- 3.2、课程目录 -->
            <div v-if="curTab == 'catalogue'" class="course-detail-catalogue">
                <div class="course-catalogue-list">
                    <course-catalogue-item v-for="tData in curCourseTableList" :key="'course-c-'+tData.id" :itemData="tData"></course-catalogue-item>
                </div>   
            </div>
        </div>

        <div v-if="curCourseInfo && curCourseInfo.needBuy < 100" class="course-pay-button-box">
            <!-- course-pay-btn-org -->
            <div v-if="curCoursePayBtnData.btnOrg" class="course-pay-button-item">
                <button class="course-pay-btn course-pay-btn-orange" :class="{'two' : curCoursePayBtnData.btnTextList[0].length == 2}" @click="clickOrangeBtn">
                    <p v-for="(bText, bI) in curCoursePayBtnData.btnTextList[0]" :key="bText">{{ curCoursePayBtnData.btnPrice && bI == '0' && vipProductData[curCoursePayBtnData.vipProductId] ? vipProductData[curCoursePayBtnData.vipProductId].price+bText : bText }}</p>
                </button>
            </div>
            <div v-if="curCoursePayBtnData.btnGreen" class="course-pay-button-item" :class="{'total' : !curCoursePayBtnData.btnOrg}">
                <button v-if="!curCoursePayBtnData.btnOrg" class="course-pay-btn course-pay-btn-green two" @click="clickGreenBtn">
                    <p v-for="(bText) in curCoursePayBtnData.btnTextList[0]" :key="bText">{{ bText }}</p>
                </button>
                <button v-else-if="curCoursePayBtnData.btnTextList[1].length == 1" class="course-pay-btn course-pay-btn-green" @click="clickGreenBtn">
                    <p>{{ curCoursePayBtnData.btnTextList[1][0] }}</p>
                </button>
                <button v-else-if="curCoursePayBtnData.btnTextList[1].length == 2" class="course-pay-btn course-pay-btn-green two" @click="clickGreenBtn">
                    <p v-for="(bText) in curCoursePayBtnData.btnTextList[1]" :key="bText">{{ bText }}</p>
                </button>
            </div>
        </div>

        <van-popup class="course-detail-popup" v-bind:value="showCDKeyPopup" @click-overlay="clickShowCDKeyOverlay">
            <div class="course-detail-pp-content">
                <div class="course-detail-pp-title">课程兑换码</div>
                <div class="course-detail-pp-input">
                    <input type="text" maxlength="8" @input="inputCDKey" v-model="CDKeyCode" placeholder="请输入课程兑换码" >
                </div>
                <div class="course-detail-pp-button">
                    <button class="course-detail-pp-confirm" :disabled="confirmDisabled" @click="clickConfirm">确定</button>
                </div>
            </div>
        </van-popup>

    </div>
</template>

<script>
import { MIX, UTILS } from '../../modules/utils';
import CourseCatalogueItem from '../../components/course/CourseCatalogueItem.vue'
export default {
    name: 'CourseDetail',
    components: { CourseCatalogueItem },
    computed: {
        curCourseInfo() {
            return this.$store.state.course.curCourseInfo;
        },
        curCoursePayInfo() {
            return this.$store.state.course.curCoursePayInfo;
        },
        curCourseTableList() {
            return this.$store.state.course.curCourseTableList;
        },
        curCoursePayBtnData() {
            return this.$store.state.course.curCoursePayBtnData;
        },
        vipProductData() {
            return this.$store.state.pay.vipProductData;
        },
    },
    data() {
        return {
            UTILS: UTILS,
            curTab: 'catalogue',
            detailContent: '',
            CDKeyCode: "",
            confirmDisabled: true,
            showCDKeyPopup: false,
            timeFn: undefined,
        }
    },
    mounted: function() {
        this.$bus.on('updateCourseDetailFunc', this.updateCourseDetail);
        setTimeout(() => {
            let cid = this.$router.history.current.params.id;
            let vip = this.$store.state.userData && this.$store.state.userData.info ? this.$store.state.userData.info.vip : 0;
            if(!this.curCourseInfo || !this.curCourseInfo.id) {
                this.$store.dispatch('course/getCourseTableList', {
                    cid: cid, vip: vip,
                    sucCb: ()=> {
                        this.initCourseDetail();
                    }
                });
            }else {
                this.initCourseDetail();
            }
            window.scrollTo(0, 0);
            MIX.trackPageViewed('CourseDetailPage');
        }, 20);
    },
    destroyed() {
        this.$bus.off('updateCourseDetailFunc', this.updateCourseDetail);
    },
    methods: {
        initCourseDetail() {
            this.clearTimeOutFunc();
            if(this.curCourseInfo.needBuy < 100) {
                this.runTimeOutFunc();
            }
            this.detailContent = UTILS.getBreakLineByText(this.curCourseInfo.f_details);
        },
        clickBack() {
            this.clearTimeOutFunc();
            let from = this.$store.state.course.courseListPageFrom;
                from = from ? from : 'my';
            if(from == 'collate_home') {
                this.$router.replace('/collate');
            }else {
                this.$router.replace('/courselist/'+from);
            }
            this.$store.dispatch('course/resetCourseDetailData');
        },
        clickCDKey() {
            this.CDKeyCode = "";
            this.confirmDisabled = true;
            this.showCDKeyPopup = true;
        },
        toggleTab(tab) {
            this.curTab = tab;
        },
        runTimeOutFunc() {
            let me = this;
            let time = this.curCourseInfo.limit_time;
            this.timeFn = async function () {
                time--;
                // console.log('runTimeOutFunc----', time, me.curCourseInfo.limitDay, me.curCourseInfo.limitTime)
                let tempData = UTILS.getDayHourMiSTimeByTime(time);
                me.$store.state.course.curCourseInfo.limitDay = tempData.day;
                me.$store.state.course.curCourseInfo.limitTime = tempData.hms;
                if(time <= 0) {
                    clearTimeout(me.timeFn);
                    return;
                }
                setTimeout(me.timeFn, 1000);
            }
            this.timeFn();
        },
        clearTimeOutFunc() {
            if(this.timeFn) {
                clearTimeout(this.timeFn);
                this.timeFn = undefined;
            }
        },
        clickOrangeBtn() {
            let vipProductData = this.$store.state.pay.vipProductData,
                curCoursePayBtnData = this.$store.state.course.curCoursePayBtnData;
            let pData = vipProductData[curCoursePayBtnData.vipProductId];
            let userVip = this.$store.state.userData ? this.$store.state.userData.info.vip : 0;
            let newUserVip = curCoursePayBtnData.vipProductId == 'pay_40001' ? 20 : (curCoursePayBtnData.vipProductId == 'pay_40002' || curCoursePayBtnData.vipProductId == 'pay_40020') ? 30 : userVip;
            console.log('clickOrangeBtn', pData, userVip, newUserVip);
            if(pData.pid == 'pay_40020') {
                this.$store.state.activity.showActAlwaysDiscountPop = true;
                MIX.trackPageViewed('ForeverVipBannerPage', 'course');
            }else {
                this.$store.dispatch('pay/createPayOrder', {
                    params: {
                        pid: pData.pid,
                        ptype: pData.payType[2],
                        discount: curCoursePayBtnData.vipDiscount
                    },
                    mixParams: {
                        pid: pData.pid,
                        product_name: pData.title,
                        price: pData.price,
                        from: 'course_detail',
                    },
                    sucCb: ()=> {
                        console.log('支付成功');
                        // 更新vip信息
                        this.$set(this.$store.state.userData, 'vip', newUserVip);
                        this.$set(this.$store.state.userData.info, 'vip', newUserVip);
                        this.$store.state.user.showVipSucPop = true;
                        this.$bus.emit('updateMyVipInfo');
                        // 更新课程信息
                        setTimeout(() => {
                            this.updateCourseDetail(newUserVip);
                        }, 1000);
                    },
                    failCb: function() {
                        console.error('支付失败----')
                    }
                });
            }
        },
        clickGreenBtn() {
            let curCoursePayInfo = this.$store.state.course.curCoursePayInfo;
            console.log('clickGreenBtn', curCoursePayInfo);
            this.$store.dispatch('pay/createPayOrder', {
                params: {
                    pid: curCoursePayInfo.pid,
                    ptype: curCoursePayInfo.payType[2],
                    discount: 1
                },
                mixParams: {
                    pid: curCoursePayInfo.pid,
                    product_name: curCoursePayInfo.title,
                    price: curCoursePayInfo.price,
                    from: 'course_detail',
                },
                sucCb: function() {
                    console.log('支付成功');
                    // 更新课程信息
                    let userVip = this.$store.state.userData ? this.$store.state.userData.info.vip : 0;
                    setTimeout(() => {
                        this.updateCourseDetail(userVip);
                    }, 300);
                },
                failCb: function() {
                    console.error('支付失败----')
                }
            });
        },
        updateCourseDetail(vip) {
            let userVip = this.$store.state.userData ? this.$store.state.userData.info.vip : 0;
                vip = vip ? vip : userVip;
            let cid = this.curCourseInfo.id;
            this.$store.dispatch('course/resetCourseListData');
            this.$store.dispatch('course/resetCourseDetailData');
            this.$store.dispatch('course/getCourseTableList', {
                cid: cid, vip: vip,
                sucCb: ()=> {
                    this.initCourseDetail();
                }
            });
        },
        clickShowCDKeyOverlay() {
            this.showCDKeyPopup = false;
        },
        inputCDKey(e) {
            this.confirmDisabled = this.CDKeyCode == "";
        },
        clickConfirm() {
            console.log('clickConfirm-----', this.CDKeyCode)
            if(this.CDKeyCode.length < 8) {
                this.$toast('请输入完整的兑换码');
                return;
            }
            this.$store.dispatch('course/useCourseKeyCode', {
                cid: this.curCourseInfo.id,
                code: this.CDKeyCode,
                sucCb: ()=> {
                    this.$toast('恭喜你兑换课程成功~');
                    // 更新课程信息
                    let userVip = this.$store.state.userData ? this.$store.state.userData.info.vip : 0;
                    setTimeout(() => {
                        this.updateCourseDetail(userVip);
                    }, 300);
                }
            })
        }
    }
}
</script>
